import {Capacitor} from "@capacitor/core";
import {Preferences} from "@capacitor/preferences";

class CapacitorPlugin {
  constructor() {
  }

  async putPayLoad(payload) {
    const orgData = await this.getNativePreference('payloadList')

    if (!orgData || orgData === '' || !Array.isArray(JSON.parse(orgData))) {
      await this.saveNativePreference('payloadList', JSON.stringify([payload]))
    } else {
      const parseData = JSON.parse(orgData)
      parseData.push(payload)
      await this.saveNativePreference('payloadList', JSON.stringify(parseData))
    }
  }

  async getLastPayload() {
    const orgData = await this.getNativePreference('payloadList')
    if (!orgData || orgData === '' || !Array.isArray(JSON.parse(orgData)) || JSON.parse(orgData).length < 1) {
      return null
    } else {
      const parseData = JSON.parse(orgData)
      const result = parseData.splice(parseData.length - 1,1)[0]
      await this.saveNativePreference('payloadList', JSON.stringify(parseData))
      return result
    }
  }

  isCapacitorMobileApp() {
    // Capacitor 환경 감지 및 alert
    try {
      // 동적 import로 Capacitor 객체를 가져옴 (빌드 환경 호환성)
      const {Capacitor} = require('@capacitor/core');
      return Capacitor && Capacitor.isNativePlatform && Capacitor.isNativePlatform();
    } catch (e) {
      // Capacitor 모듈이 없으면 브라우저로 간주
      return false
    }
  }


  /**
   * capacitor로 제작된 모바일 App의 네이티브 영역에서 사용할 정보를 저장
   * @param key
   * @param value
   * @return {Promise<void>}
   */
  async saveNativePreference(key, value) {
    try {
      const {Preferences} = require('@capacitor/preferences')
      await Preferences.set({key, value});
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * capacitor로 제작된 모바일 App의 저장된 정보를 불러옴
   * Android와 동일하게 CapacitorStorage에서 읽기
   * @param key
   * @return {Promise<undefined|string>}
   */
  async getNativePreference(key) {
    try {
      const {Preferences} = require('@capacitor/preferences')
      
      let {value} = await Preferences.get({key});
      
      if (!value) {
        const storageResult = await Preferences.get({key: `CapacitorStorage.${key}`});
        value = storageResult.value;
      }
      
      return value;
    } catch (e) {
      console.error('getNativePreference error:', e);
      return undefined;
    }
  }

  /**
   * capacitor로 제작된 모바일 App의 저장된 정보를 삭제함
   * @param key
   * @return {Promise<undefined|string>}
   */
  async removeNativePreference(key) {
    try {
      const {Preferences} = require('@capacitor/preferences')
      await Preferences.remove({key});
    } catch (e) {
      console.error(e);
    }
  }

  async getDeviceInfo () {
    const { Device } = window.Capacitor?.Plugins || {}

    const result = {
      deviceId: undefined,
      deviceType: undefined,
    }

    if (Device) {
      const deviceInfo = await Device.getInfo()
      
      if (!!deviceInfo.platform && ['android', 'ios'].includes(deviceInfo.platform.toLowerCase())) {
        result.deviceType = deviceInfo.platform.toLowerCase() === "android" ? "Android" : "iOS"
      }
      
      if (result.deviceType === 'iOS' && window.CapacitorDeviceInfo?.deviceId) {
        result.deviceId = window.CapacitorDeviceInfo.deviceId
      } else {
        result.deviceId = await this.getNativePreference('deviceId')
      }
    }
    return result
  }

  /**
   * 포어그라운드 상태일 때도 노티를 띄우기 위한 인위적으로 아래 로직을 실행
   * @param notification
   */
  async showNotification(notification) {
    const {LocalNotifications} = window.Capacitor.Plugins || {};

    // 포어그라운드 상태일 때도 노티를 띄우기 위한 인위적으로 아래 로직을 실행
    if (!!LocalNotifications) {
      try {
        // 알림 권한 확인
        const permissionStatus = await LocalNotifications.checkPermissions();
        console.log('LocalNotifications permission status:', permissionStatus);
        
        // 권한이 없으면 알림을 띄우지 않음 (앱 강제 종료 방지)
        if (permissionStatus.display !== 'granted') {
          console.warn('LocalNotifications permission not granted, skipping notification');
          return;
        }
        
        // 권한이 있을 때만 알림 표시
        await LocalNotifications.schedule({
          notifications: [
            {
              title: notification.title,
              body: notification.body,
              id: this.stringToNumberId(notification.id),
              smallIcon: "ic_stat_notify"
            }
          ]
        });
      } catch (error) {
        // 에러 발생 시 로그만 출력하고 앱은 계속 실행
        console.error('Failed to show notification:', error);
      }
    }
  }

  /**
   * FCM MessageId로 notification 에서 사용될 ID 로 변경
   * @param str
   * @return {number}
   */
  stringToNumberId(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash = hash & hash; // 32bit 정수로 변환
    }
    // 양수로 변환, 32비트 정수 범위 제한
    return Math.abs(hash % 2147483647);
  }
}


const capacitorPlugin = new CapacitorPlugin
export {
  capacitorPlugin
}